import React from "react"
import {withFormik} from 'formik';
import {FormattedMessage, injectIntl} from "react-intl";
import {displayErrors, parsePropertiesErrors} from "../../../../form-helpers";
import BaseComponent from "../../../base-component";
import HealthInsuranceCoSelect from "../../../health-insurance-co-select";
import BankCoSelect from "../../../bank-co-select";
import Cleave from 'cleave.js/src/Cleave.react';

class Page4 extends BaseComponent {

    constructor(params) {
        super(params);
    }

    render() {
        const { intl, values, touched, errors, handleChange, handleBlur, handleSubmit, submitForm, isSubmitting, setFieldValue, isComplete, resource } = this.props;
        const allowHealthCoNotYet = resource.data['citizenship'] !== 'CZE';

        return (
            <form onSubmit={handleSubmit}>
                <h3><FormattedMessage id='app.personal_forms.page_4.title'/></h3>
                <p><FormattedMessage id='app.personal_forms.page_4.info'/></p>
                <p><FormattedMessage id='app.personal_forms.message.required_fields'/> (<span className='text-red'>*</span>)</p>
                <hr/>
                { displayErrors(errors, 'base') }

                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.health_insurance_company'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <HealthInsuranceCoSelect disabled={isComplete} allowNotYet={allowHealthCoNotYet} value={values.data.health_insurance_company} onChange={(value) => { setFieldValue('data.health_insurance_company', value) }}/>
                            { displayErrors(errors, 'data.health_insurance_company') }
                        </div>
                    </div>
                </div>

                {
                    values.data.health_insurance_company && values.data.health_insurance_company.length > 0 &&
                    <div className='form-group'>
                        <div className="custom-control custom-switch pb-2">
                            <input disabled={isComplete} type="checkbox" className="custom-control-input" id='data.health_insurance_info' checked={values.data.health_insurance_info} onChange={handleChange}/><label className="custom-control-label" htmlFor="data.health_insurance_info"><span className='required-field'><FormattedMessage id='app.personal_forms.attribute.health_insurance_info'/></span></label>
                        </div>
                        { displayErrors(errors, 'data.health_insurance_info') }
                    </div>
                }

                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.bank_account'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                        </div>
                        {
                            !values.data.bank_account_none &&
                            <div>
                                <div className='form-group'>
                                    <FormattedMessage id='app.personal_forms.attribute.bank_co'>{(txt) => (<label className='small'>{txt}</label>)}</FormattedMessage>
                                    <BankCoSelect disabled={isComplete} value={values.data.bank_co} onChange={(value) => { setFieldValue('data.bank_co', value) }}/>
                                    { displayErrors(errors, 'data.bank_co') }
                                </div>
                                <div className='row'>
                                    <div className='col-md-5'>
                                        <div className='form-group'>
                                            <FormattedMessage id='app.personal_forms.attribute.bank_account_prefix'>{(txt) => (<label className='small'>{txt}</label>)}</FormattedMessage>
                                            <Cleave options={{
                                                numericOnly: true,
                                                blocks: [6]
                                            }}
                                                    value={values.data.bank_account_prefix}
                                                    disabled={isComplete}
                                                    className={'form-control'}
                                                    onChange={(event) => { setFieldValue('data.bank_account_prefix', event.target.rawValue) }} />
                                            { displayErrors(errors, 'data.bank_account_prefix') }
                                        </div>
                                    </div>
                                    <div className='col-md-7'>
                                        <div className='form-group'>
                                            <FormattedMessage id='app.personal_forms.attribute.bank_account_number'>{(txt) => (<label className='small'>{txt}</label>)}</FormattedMessage>
                                            <Cleave options={{
                                                numericOnly: true,
                                                blocks: [10]
                                            }}
                                                    value={values.data.bank_account_number}
                                                    disabled={isComplete}
                                                    className={'form-control'}
                                                    onChange={(event) => { setFieldValue('data.bank_account_number', event.target.rawValue) }} />
                                            { displayErrors(errors, 'data.bank_account_number') }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className='form-group'>
                            <div className="custom-control custom-switch pb-2">
                                <input disabled={isComplete} type="checkbox" className="custom-control-input" id='data.bank_account_none' checked={values.data.bank_account_none} onChange={handleChange}/><label className="custom-control-label" htmlFor="data.bank_account_none"><FormattedMessage id='app.personal_forms.attribute.bank_account_none'/></label>
                            </div>
                            { displayErrors(errors, 'data.bank_account_none') }
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-12'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.income_deductions'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage><br/>
                            <div className='custom-control custom-radio'>
                                <input className='custom-control-input' disabled={isComplete} id='data.income_deductions' name='data.income_deductions' type="radio" value={values.data.income_deductions} checked={values.data.income_deductions === '1'} onChange={() => { setFieldValue('data.income_deductions', '1') }} onBlur={handleBlur}/>
                                <label className='custom-control-label' onClick={() => { !isComplete && setFieldValue('data.income_deductions', '1') }}><FormattedMessage id='app.personal_forms.attribute.income_deductions.true'/></label>
                            </div>
                            <div className='custom-control custom-radio'>
                                <input className='custom-control-input' disabled={isComplete} id='data.income_deductions' name='data.income_deductions' type="radio" value={values.data.income_deductions} checked={values.data.income_deductions === '0'} onChange={() => { setFieldValue('data.income_deductions', '0') }} onBlur={handleBlur}/>
                                <label className='custom-control-label' onClick={() => { !isComplete && setFieldValue('data.income_deductions', '0') }}><FormattedMessage id='app.personal_forms.attribute.income_deductions.false'/></label>
                            </div>
                            { displayErrors(errors, 'data.income_deductions') }
                        </div>
                    </div>
                </div>

                <div className='form-group'>
                    <div className="custom-control custom-switch pb-2">
                        <input disabled={isComplete} type="checkbox" className="custom-control-input" id='data.income_deductions_info' checked={values.data.income_deductions_info} onChange={handleChange}/><label className="custom-control-label" htmlFor="data.income_deductions_info"><span className='required-field'><FormattedMessage id='app.personal_forms.attribute.income_deductions_info'/></span></label>
                    </div>
                    { displayErrors(errors, 'data.income_deductions_info') }
                </div>

                <FormattedMessage id='app.personal_forms.attribute.education'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                <p className='text-muted small shift'><FormattedMessage id='app.personal_forms.attribute.education_school.info'/></p>

                <div className='row'>
                    <div className='col-12'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.education_school'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.education_school' value={values.data.education_school} onChange={handleChange}/>
                            { displayErrors(errors, 'data.education_school') }
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.education_school_start'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <select disabled={isComplete} id='data.education_school_start' value={values.data.education_school_start} onChange={handleChange} className='form-control'>
                                <option value=''>-</option>
                                { Array.from({length: 80}, (v, k) => (new Date().getFullYear()) - k).map((year) => (
                                        <option key={year}>{year}</option>
                                    )
                                ) }
                            </select>
                            { displayErrors(errors, 'data.education_school_start') }
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.education_school_end'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <select disabled={isComplete} id='data.education_school_end' value={values.data.education_school_end} onChange={handleChange} className='form-control'>
                                <option value=''>-</option>
                                { Array.from({length: 80}, (v, k) => (new Date().getFullYear()) - k).map((year) => (
                                        <option key={year}>{year}</option>
                                    )
                                ) }
                            </select>
                            { displayErrors(errors, 'data.education_school_end') }
                        </div>
                    </div>
                </div>
                <div className='clearfix'>
                    <hr/>
                    <button type='button' className='btn btn-secondary' onClick={this.props.previous}>{intl.formatMessage({id: 'app.personal_forms.buttons.previous_step'})}</button>
                    { !isComplete && <button type='submit' className='btn btn-primary float-right' disabled={isSubmitting}>{intl.formatMessage({id: 'app.personal_forms.buttons.next_step'})}{this.spinner(isSubmitting)}</button> }
                    { isComplete && <button type='button' className='btn btn-primary float-right' onBlur={handleBlur} onClick={this.props.next}>{intl.formatMessage({id: 'app.personal_forms.buttons.next_step'})}</button> }
                </div>
            </form>
        )
    }

}

export default injectIntl(withFormik({
    enableReinitialize: true,
    mapPropsToValues: (props) => {
        let model = { data: { ...props.resource.data, page: 5 } };
        return model;
    },
    handleSubmit: (values, form) => { form.props.submit(values, form); },
    displayName: 'BasicForm',
})(Page4));
